export default __webpack_public_path__ + "static/media/Logo Isolis-11.fa43cc82.png";